import { GetterTree } from 'vuex'
import { RootState } from '@/store/types';
import { ApplicationAttributeState } from './types';

export const getters: GetterTree<ApplicationAttributeState, RootState> = {
  applicationAttributes: state => state.applicationAttributes,
  applicationAttribute: state => state.applicationAttribute,
  attributeTypeList: state => state.attributeTypeList,
  attributeOwnerList: state => state.attributeOwnerList,
}
